import {ExistingPlayerOnboardingContainer} from '@/components/PageContainer/ExistingPlayerOnboardingContainer';
import {Outlet} from 'react-router-dom';

export const ExistingPlayerOnboardingLayout = () => {
  return (
    <ExistingPlayerOnboardingContainer>
      <Outlet />
    </ExistingPlayerOnboardingContainer>
  );
};
